import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgCheckDoubleIcon = ({
  title,
  theme = null,
  titleId = "",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="check_double_svg__nc-icon-wrapper">
      <path
        d="M60.3 11.388 31.4 46.274l-4.652-4.651-1.922 2.32 5.617 5.618A1.5 1.5 0 0 0 31.5 50h.07a1.5 1.5 0 0 0 1.085-.541L62.612 13.3Z"
        data-color="color-2"
      />
      <path d="M16.5 50a1.5 1.5 0 0 1-1.061-.439L1.379 35.5 3.5 33.379l12.9 12.9 28.9-34.891 2.31 1.914-29.955 36.155A1.5 1.5 0 0 1 16.57 50Z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgCheckDoubleStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgCheckDoubleIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const CheckDoubleIcon: any = SvgCheckDoubleStyle;
export default CheckDoubleIcon;
